import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {repoRouteBuilder} from '../config/repo-route-builder'
import type {CommitPayload} from '../types/commit-types'

export function buildCommitPathRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('commitPathRoute', {
    path: '/:owner/:repo/commit/:oid/:path/*',
    queries: [
      mainQuery<CommitPayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
      }),
    ],
  })
}

export const commitPathRoute = buildCommitPathRoute(repoRouteBuilder)
